import React from 'react';
import ListaPropiedades from './tables/ListaPropiedades';

const GestionarPropiedades = () => {
  return <ListaPropiedades />;
};

export default GestionarPropiedades;
